<template>
  <div class="advance-journal">
    <article v-for="group in groups" :key="group.correlation_id">
      <header>
        <strong>{{ names[group.kind] || group.kind }}</strong>
        <span>{{ group.status === 'COMPENSATED' ? 'Отменено' : group.status === 'PENDING_CLOSE' ? 'Ожидает закрытия' : 'Проведено' }}</span>
        <span>{{ group.actor_name }} · {{ date(group.created_at) }}</span>
        <button v-if="canCancel && group.status === 'POSTED' && ['PAYMENT', 'TRANSFER', 'REPLENISH'].includes(group.kind)"
          :disabled="busy" @click="$emit('cancel', group)">Отменить группу</button>
      </header>
      <div class="uuid">Группа: {{ group.correlation_id }} · Период: {{ group.period_id }}</div>
      <p v-if="group.comment">{{ group.comment }}</p>
      <table>
        <thead><tr><th>Операция</th><th>Источник → получатель</th><th>Списано / получено</th><th>Контекст</th></tr></thead>
        <tbody><tr v-for="event in group.transactions" :key="event.id">
          <td>{{ names[event.kind] || event.kind }}<small v-if="event.original_transaction_id">Отмена {{ event.original_transaction_id }}</small></td>
          <td>{{ event.context.source_name || event.source_id || '—' }} → {{ event.context.target_name || event.context.row?.name || event.target_id || '—' }}</td>
          <td>{{ money(event.source_amount) }} / {{ money(event.target_amount) }}</td>
          <td>
            <span v-if="event.context.trip_number">Рейс {{ event.context.trip_number }} · </span>
            <span v-if="event.context.client_name">{{ event.context.client_name }} × {{ event.context.client_coefficient }} · </span>
            <span v-if="event.context.transfer_coefficient">Перевод × {{ event.context.transfer_coefficient }} · </span>
            <span v-if="event.context.payment_term_name">{{ event.context.payment_term_name }}</span>
          </td>
        </tr></tbody>
      </table>
    </article>
    <p v-if="!groups.length">Операций пока нет.</p>
  </div>
</template>

<script>
import { transactionNames } from '../advanceState.mjs';
export default {
  name: 'AdvanceJournal',
  props: { groups: { type: Array, default: () => [] }, canCancel: Boolean, busy: Boolean },
  emits: ['cancel'],
  data: () => ({ names: transactionNames }),
  methods: {
    money: value => Number(value || 0).toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    date: value => value ? new Date(value).toLocaleString('ru-RU') : '',
  },
};
</script>

<style scoped>
article { border: 1px solid #dbe2ea; border-radius: 8px; margin: 10px 0; padding: 10px; }
header { display: flex; flex-wrap: wrap; align-items: center; gap: 12px; }
.uuid, small { display: block; font-size: 11px; color: #667085; overflow-wrap: anywhere; }
table { width: 100%; border-collapse: collapse; margin-top: 8px; }
th, td { text-align: left; padding: 7px; border-bottom: 1px solid #edf0f4; }
</style>
